import { useState } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

const images = ["/Home/RaastQr.jpg", "/Home/Final-Scam-Alert1.jpg"];

const ImagePopUp = () => {
  const [show, setShow] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);

  if (!show) return null;

  const nextImage = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-[9999]">
      <div className="relative bg-white rounded-lg shadow-lg p-0 flex items-center">
        <button
          onClick={() => setShow(false)}
          className="absolute top-3 right-3 text-[red]  hover:text-red-500 z-20"
        >
          <X size={24} />
        </button>

        <button
          onClick={prevImage}
          className="absolute left-1  top-[53%] transform -translate-y-1/2 z-20"
        >
          <ChevronLeft size={32} className="text-white" />
        </button>

        <img
          src={images[currentIndex]}
          alt={`Scam Alert ${currentIndex + 1}`}
          className="w-[500px] h-auto rounded"
        />

        <button
          onClick={nextImage}
          className="absolute right-1 top-[53%] transform -translate-y-1/2 z-20"
        >
          <ChevronRight size={32} className="text-white" />
        </button>
      </div>
    </div>
  );
};

export default ImagePopUp;
